module.exports = __webpack_public_path__ + "img/3@2x (3).ad6587a6.png";